import { MainMenuOption } from 'src/service/MainMenu';
import { AbstractUserRole } from 'src/service/UserPermission/AbstractUserRole';
import { Event, Fixture, Role, Tournament, User } from 'src/api';

export class TournamentAdminRole extends AbstractUserRole {
  canView(option: MainMenuOption): boolean {
    const allowed = [
      MainMenuOption.home,
      MainMenuOption.tournament,
      MainMenuOption.venue,
    ];
    return allowed.includes(option);
  }

  canEditTournament(tournament: Tournament): boolean {
    return this.list.has(tournament.id ?? 0);
  }

  canAddMDDToFixture(fixture: Fixture): boolean {
    return this.list.has(fixture.tournament?.id ?? 0);
  }

  canEditUser(user: User): boolean {
    // if user is a Match Day Doctor in a tournament i admin
    return (
      user.roles?.some(
        (role) =>
          role.role === Role.Match_Day_Doctor &&
          this.list.has(role.tournament?.id ?? 0),
      ) ?? false
    );
  }

   
  canDownloadEventPdf(event: Event): boolean {
    return true;
  }

  canToggleICCCompliance(): boolean {
    return true;
  }
}
